export default __webpack_public_path__ + "static/starNightSee-de8983a29ebba0eed68599c91dbab149.png";